import { hasRequiredShopifyParams } from '@bundles/libs'
import InstallPage from '@bundles/pages/auth/InstallPage'
import AppDataProvider from '@bundles/providers/AppDataProvider'
import { RouterWrapper } from '@bundles/routes/RouterWrapper'
import type React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
const AppRoutes: React.FC = () => {
  const needsInstall = !hasRequiredShopifyParams()
  if (needsInstall) {
    return (
      <Routes>
        <Route path="/auth/install" element={<InstallPage />} />
        <Route path="/*" element={<Navigate to="/auth/install" replace />} />
      </Routes>
    )
  }
  return (
    <AppDataProvider>
      <Routes>
        <Route path="/auth/install" element={<InstallPage />} />
        <Route path="/*" element={<RouterWrapper />} />
      </Routes>
    </AppDataProvider>
  )
}

export default AppRoutes
